import React from 'react';
import { motion } from 'framer-motion';
import { QUIENES_SOMOS_FEATURES } from '../constants';

export const QuienesSomos: React.FC = () => {
  return (
    <section id="quienes-somos" className="py-24 relative overflow-hidden" style={{ background: 'linear-gradient(#f8fafc 0%, #ffffff 100%)' }}>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-teal-400/5 rounded-full blur-[100px] pointer-events-none" />

      <div className="container mx-auto px-4 max-w-7xl relative z-10">
        {/* Hero Image */}
        <div className="relative rounded-2xl overflow-hidden mb-16">
          <img
            src="/persona-hombre-restaurante.jpg"
            alt=""
            className="w-full h-[200px] md:h-[300px] object-cover"
            loading="lazy"
            style={{ objectPosition: '50% 28%' }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#f8fafc] via-[#f8fafc]/70 to-[#f8fafc]/40" />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <span
              className="inline-flex items-center gap-2 py-1 px-4 rounded-full text-sm font-bold mb-4 uppercase tracking-widest"
              style={{
                background: 'rgba(43,95,111,0.1)',
                border: '1px solid rgba(43,95,111,0.25)',
                color: '#2b5f6f',
              }}
            >
              Quiénes somos
            </span>
            <h2
              className="font-black text-slate-900 mb-2"
              style={{ fontSize: 'clamp(1.8rem, 5vw, 3rem)', letterSpacing: '-0.02em' }}
            >
              Automatización con criterio, no con humo
            </h2>
            <p className="text-slate-700 font-medium text-sm md:text-base max-w-xl">
              Somos un equipo técnico en Madrid especializado en hacer que los negocios locales funcionen mejor.
            </p>
          </div>
        </div>

        {/* Two-Column Layout */}
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left Column */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <div className="bg-slate-200 rounded-2xl mb-8">
              <img
                src="/img/dashboard-mockup.jpg"
                alt="Dashboard de métricas — reservas, clientes y automatizaciones"
                className="rounded-2xl shadow-lg w-full"
                loading="lazy"
                style={{ border: '1px solid rgba(43,95,111,0.12)' }}
              />
            </div>
            <div className="space-y-5">
              <ul className="space-y-4 text-slate-600">
                <li className="flex items-start gap-3">
                  <span className="text-emerald-500 font-bold flex-shrink-0">✦</span>
                  <span>
                    Nacimos de una frustración: negocios con buen producto que pierden clientes por no contestar a tiempo, citas que no llegan y horas dedicadas a tareas que una máquina haría en segundos.
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-emerald-500 font-bold flex-shrink-0">✦</span>
                  <span>
                    No somos agencia ni consultora. Somos técnicos que montamos sistemas reales: asistente WhatsApp, recordatorios que reducen cancelaciones y campañas que se envían solas.
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-emerald-500 font-bold flex-shrink-0">✦</span>
                  <span>
                    Especializados en negocios locales de Madrid: restaurantes, clínicas, peluquerías, estudios de tatuaje y servicios. Gente que vive de su trabajo y no tiene tiempo para tecnología que no funciona.
                  </span>
                </li>
              </ul>
              <p className="text-slate-700 font-medium">
                Si lo que montamos no te ahorra tiempo o dinero en el primer mes, lo desmontamos. Sin preguntas.
              </p>
            </div>
          </motion.div>

          {/* Right Column — Feature Cards */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="space-y-4"
          >
            {QUIENES_SOMOS_FEATURES.map((f, idx) => (
              <div
                key={idx}
                className="flex gap-4 p-5 rounded-2xl transition-all duration-300 hover:shadow-lg"
                style={{
                  background: 'rgba(43,95,111,0.04)',
                  border: '1px solid rgba(43,95,111,0.1)',
                }}
              >
                <div className="flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center bg-gradient-to-br from-teal-500/20 to-teal-400/10">
                  <span className="w-2 h-2 rounded-full bg-teal-500" />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900 text-sm mb-1">{f.title}</h4>
                  <p className="text-slate-600 text-xs leading-relaxed">{f.description}</p>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};
